export default () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    flexGrow: '1',
    paddingBottom: 12
  }
});